export const EXTENSION_SETTINGS_INIT = {
  autoTestNewNetworks: true,
  autoTestAfterServiceInterruption: false,
  enableDailyTesting: true,
};
